import {SlDetails} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';

export class InternetDetailManager {
    private readonly viewRoot: HTMLElement;

    constructor(viewroot: HTMLElement) {
        this.viewRoot = viewroot;
        this.registerEventChooseAddress();
        this.registerEventChangeAddress();
        this.registerEventFormSubmit();
        this.registerEventResetAddress();
    }

    private registerEventChooseAddress(): void {
        const chooseDSLAddresses = this.viewRoot.querySelectorAll<HTMLAnchorElement>('.chooseDSLAddress');

        if (chooseDSLAddresses.length === 0) {
            return;
        }
        chooseDSLAddresses.forEach((chooseDSLAddress) => {
            chooseDSLAddress.addEventListener('click', (event: Event) => {
                event.preventDefault();

                const form = chooseDSLAddress.closest('form') as HTMLFormElement;
                if (!form) {
                    return;
                }

                const zip = notNull(form.querySelector('[name="availability[zip]"]')) as HTMLInputElement;
                zip.value = notNull(chooseDSLAddress.dataset.zip);

                const city = notNull(form.querySelector('[name="availability[city]"]')) as HTMLInputElement;
                city.value = notNull(chooseDSLAddress.dataset.city);

                const street = notNull(form.querySelector('[name="availability[street]"]')) as HTMLInputElement;
                street.value = notNull(chooseDSLAddress.dataset.street);

                const street_no = notNull(form.querySelector('[name="availability[street_no]"]')) as HTMLInputElement;
                street_no.value = notNull(chooseDSLAddress.dataset.street_no);

                const supplement = notNull(form.querySelector('[name="availability[supplement]"]')) as HTMLInputElement;
                supplement.value = notNull(chooseDSLAddress.dataset.supplement);

                form.submit();
            });
        });
    }

    private registerEventChangeAddress(): void {
        const changeDSLAddress = this.viewRoot.querySelector('.changeDSLAddress');
        if (!changeDSLAddress) {
            return;
        }
        changeDSLAddress.addEventListener('click', () => {
            const availablecheck = this.viewRoot.querySelector('#tarif-check-available');
            if (availablecheck) {
                availablecheck.classList.remove('hidden');
            }

            const tarifavailable = this.viewRoot.querySelector('#tarif-available');
            if (tarifavailable) {
                tarifavailable.classList.add('hidden');
            }

            const checkOnDetail = this.viewRoot.querySelector('#tarif-check-available sl-details') as SlDetails;
            if (!checkOnDetail) {
                return;
            }
            checkOnDetail.show();
        });
    }

    private registerEventFormSubmit(): void {
        const form = this.viewRoot.querySelector('#dsl-detail-form') as HTMLFormElement;
        if (!form) {
            return;
        }
        const body = notNull(document.querySelector('body')) as HTMLBodyElement;

        form.addEventListener('submit', (event) => {
            event.preventDefault();
            body.classList.add('loadingdsl');

            form.submit();
        });
    }

    private registerEventResetAddress(): void {
        const clearBeratungsFilterDetail = this.viewRoot.querySelector('.clearBeratungsFilterDetail') as HTMLAnchorElement;
        if (!clearBeratungsFilterDetail) {
            return;
        }
        clearBeratungsFilterDetail.addEventListener('click', (event) => {
            event.preventDefault();
            const form = clearBeratungsFilterDetail.closest('form');
            if (!form) {
                return;
            }
            const clearBeratungsFilter = notNull(form.querySelector('[name="clearBeratungsFilter"]')) as HTMLInputElement;
            clearBeratungsFilter.value = '1';
            form.submit();
        });
    }
}
